const products = require('@aboutdotme/products')

// thin wrapper around @products

module.exports = products
